import { singleton } from 'tsyringe';

@singleton()
export default class Env {
  getValue(key: string, defaultValue?: string): string {
    if (!process.env[key]) {
      if (!defaultValue) throw new Error(`Missing ${key} in process.env`);
      return defaultValue;
    }

    return process.env[key] as string;
  }
}
